// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"08198876","404":"f9680fde","488":"6a262937","592":"a57f7a9b"}[chunkId] + ".chunk.js";
};